import httpClient from "./httpClient";

const getNews = ( page , pageSize) => httpClient.get(`/Announcments?page=${page}&pageSize=${pageSize}` ,).then(
  (response) => {return response.data}
)

const postNews = (params) => httpClient.post(`/Announcments`, {
  title : params.title ,
   text : params.text ,
  date : params.date,
  file : params.file,
  images: params.images

}, { headers: { Authorization: `Bearer ${localStorage.getItem('lotusToken')}` }})

const putNews = (params ) => httpClient.put(`/Announcments/${params.id}`, params,
  { headers: { Authorization: `Bearer ${localStorage.getItem('lotusToken')}` }})
const deleteNews = (id) => httpClient.delete(`/Announcments/${id}`, { headers: { Authorization: `Bearer ${localStorage.getItem('lotusToken')}` }})
export  {
  getNews ,
  postNews,
  putNews,
  deleteNews

}
